<script lang="ts">
    import { setTypedContext } from "@lib/svelte-typed-context";

    import { formManagerToken } from "./context_tokens";
    import FormManager from "./FormManager";

    export let formManager: FormManager;
    setTypedContext(formManagerToken, formManager);
</script>

<slot />
